export const DashboardUrls = {
	addUrl: '/projects/add',
	viewAll: '/projects',
};
